// extracted by mini-css-extract-plugin
export var quillEditor = "_pu-1";
export var variable = "_pu-0";